
export const trimStr = (v) => String(v ?? "").trim();

export const normalize = (v) =>
  Array.isArray(v) ? v.map((x) => trimStr(x)) : trimStr(v);

export const getLabel = (q) =>
  q?.questionText?.en || q?.title?.en || q?.questionText?.fr || q?.title?.fr || "";

export const findQuestionByField = (allQs, fieldLabel) => {
  const target = trimStr(fieldLabel);
  return (
    allQs.find((x) => trimStr(x?.questionText?.en) === target) ||
    allQs.find((x) => trimStr(x?.title?.en) === target) ||
    allQs.find((x) => trimStr(x?.questionText?.fr) === target) ||
    allQs.find((x) => trimStr(x?.title?.fr) === target)
  );
};


export const buildComparablesForValue = (targetQ) => {
  const value = targetQ?.value;
  const allowed = targetQ?.props?.allowedValues || [];
  const idToLabels = new Map(
    allowed.map((av) => [String(av.id), [trimStr(av.name_en), trimStr(av.name_fr)]])
  );

  const addForId = (acc, id) => {
    const idStr = trimStr(id);
    if (!idStr) return acc;
    acc.add(idStr);
    const labels = idToLabels.get(idStr);
    if (labels) labels.forEach((lbl) => acc.add(lbl));
    return acc;
  };

  const set = new Set();
  if (Array.isArray(value)) {
    value.forEach((id) => addForId(set, id));
  } else if (value != null && value !== "") {
    addForId(set, value);
    set.add(trimStr(value));
  }
  return set;
};

export const evalQuestionsAtomic = (cond, allQs) => { // fieldName eq value
  const op = (cond?.op || "eq").toLowerCase();
  const targetQ = findQuestionByField(allQs, cond?.field);
  const comparables = buildComparablesForValue(targetQ);
  const expectedArr = Array.isArray(cond?.value) ? cond.value.map(trimStr) : [trimStr(cond?.value)];

  let result = false;
  switch (op) {
  case "in":
  case "eq":
    result = expectedArr.some((exp) => comparables.has(exp));
    break;
  case "neq":
    result = expectedArr.every((exp) => !comparables.has(exp));
    break;
  default:
    result = false;
    break;
}

  const actualShown =
    Array.isArray(targetQ?.value) ? targetQ.value.map(trimStr) : trimStr(targetQ?.value);
  let actualResolved = actualShown;
  if (Array.isArray(targetQ?.value)) {
    actualResolved = targetQ.value
      .map((id) => {
        const av = (targetQ?.props?.allowedValues || []).find((x) => String(x.id) === String(id));
        return av ? `${id} (${trimStr(av.name_en)})` : id;
      })
      .join(", ");
  } else if (targetQ?.value != null && targetQ?.value !== "") {
    const av = (targetQ?.props?.allowedValues || []).find((x) => String(x.id) === String(targetQ.value));
    actualResolved = av ? `${targetQ.value} (${trimStr(av.name_en)})` : targetQ.value;
  }

  return {
    field: cond?.field,
    op,
    expected: expectedArr,
    actual: actualShown,
    actualResolved,
    result,
    targetLabel: getLabel(targetQ),
    targetType: targetQ?.questionType || null,
  };
};

export const matchAllconditionsInQuestions = (conds, allQs) => {
  if (!conds || !conds.length) return { ok: true, details: [] };
  const details = conds.map((c) => evalQuestionsAtomic(c, allQs));
  const ok = details.every((d) => d.result);
  return { ok, details };
};
